<template>
<div class="cascade-checker-second-wrapper">
  <div class="radio-wrapper" v-if="type === 'radio'">
    <rich-radio-group>
      <div
        v-for="(item, index) in options"
        :key="'option_' + index"
      >
        <rich-radio
          :option="item"
          v-model="checkerValue"
        ></rich-radio>
        <div class="pl-30" v-if="item.matterOptions && item.value === checkerValue">
          <matter ref="matter" :result="item.value" :options="item.matterOptions" @input="secondMatterChange"/>
        </div>
        <template
          v-if="item.props && item.props.needOther && !item.matterOptions"
        >
          <span
          class="check-required"
          v-show="checkerList.includes(item.value)"
          >*</span>
          <component
            v-for="(nextItem, idx) in item.props.config"
            :key="'config' + idx"
            v-show="item.value === checkerValue"
            :is="nextItem.type || 'rich-textarea'"
            v-model="nextItem.otherValue"
            v-bind="nextItem"
            :class="{
              'pl-30': nextItem.indent
            }"
            @input="textareaChange(item.value, nextItem)"
          />
          <div
            class="error-msg"
            v-if="errmsgs[item.value] && checkerList.includes(item.value)"
            v-text="errmsgs[item.value]"
          ></div>
        </template>
      </div>
    </rich-radio-group>
  </div>
  <div v-else-if="type === 'checkbox'">
    <rich-checkbox-group
      v-model="checkerList"
      @input="change"
    >
      <div
        v-for="(item, index) in options"
        :key="'option_checkbox' + index"
      >
        <rich-checkbox
          :option="item"
        ></rich-checkbox>
        <div class="pl-30" v-if="item.matterOptions && checkerList.includes(item.value)">
          <matter ref="matter" :result="item.value" :options="item.matterOptions" @input="e => secondMulMatterChange(e, item.value)"/>
        </div>
        <template
          v-if="item.props && item.props.needOther && !item.matterOptions"
        >
          <span
          class="check-required"
          v-show="checkerList.includes(item.value) && item.props.config.length < 2"
          >*</span>
          <component
            v-for="(nextItem, idx) in item.props.config"
            :key="'config' + idx"
            v-show="checkerList.includes(item.value)"
            :is="nextItem.type || 'rich-textarea'"
            v-model="nextItem.otherValue"
            v-bind="nextItem"
            @input="textareaChange(item.value, nextItem)"
          />
          <div
            class="error-msg"
            v-if="errmsgs[item.value] && checkerList.includes(item.value)"
            v-text="errmsgs[item.value]"
          ></div>
        </template>
      </div>
    </rich-checkbox-group>
  </div>
   <div
    class="error-msg"
    v-if="showErr"
    v-text="errmsg"
  ></div>
</div>
</template>
<script>
import { i18n } from '@/common/utils/i18n'
import { get, isArray, isFunction } from 'lodash-es'
import uploadimg from '@/pages/visit/addvisit/uploadimg.vue'
import phone from '@/components/PhoneInput'
import matter from './CascadeMatterChecker.vue'

const errmsg = i18n.gettext('选项和输入框不能为空')
// 取消选中之后  delete 相应数据
export default {
  name: 'CascadeSecondChecker',
  components: {
    uploadimg,
    phone,
    matter
  },
  props: {
    // type  options[ value, label, props: [needOther, otherValue, placeholder] ]
    result: {
      required: true,
      type: Number
    },
    type: {
      required: false,
      type: String, // checkbox radio
      default: 'radio'
    },
    options: {
      required: true,
      type: Array
    },

    second: {}
  },
  data () {
    return {
      checkerValue: '',
      checkerList: [],
      matter: '',
      remark: '',
      otherMap: {},
      showErr: false,
      errmsg: errmsg,
      errmsgs: {}
    }
  },
  watch: {
    checkerValue (nVal, oVal) {
      nVal !== oVal && this.change()
    }
  },
  created () {
    if (this.second) { this.initValue(false, this.second) }
  },
  methods: {
    initValue (reset, second) {
      if (reset) {
        this.checkerValue = ''
        this.checkerList = []
      } else {
        if (this.type === 'radio') {
          this.checkerValue = second.value[0] || ''
        } else {
          this.checkerList = second.value || []
        }
        this.otherMap = second.other || {}
      }

      this.initOtherMap(reset)
    },
    initOtherMap (reset) {
      let otherMapKeys = Object.keys(this.otherMap)
      if (otherMapKeys.length && this.options.length) {
        otherMapKeys.forEach(key => {
          let other = this.options.find(item => {
            return item.value === (key - 0)
          })
          if (other && other.props && other.props.config) {
            other.props.config.forEach(item => {
              let val = reset ? '' : get(this.otherMap, [key, item.prop], '')
              item.otherValue = val || (isArray(item.otherValue) ? [] : '')
            })
          }
        })
      }
      if (reset) {
        this.$nextTick(() => {
          this.otherMap = {}
        })
      }
    },
    showSecond (value, checkerValue) {
      return isArray(checkerValue) ? checkerValue.includes(value) : (checkerValue === value)
    },
    getValue () {
      return this.type === 'radio'
        ? this.checkerValue
          ? [this.checkerValue]
          : []
        : this.checkerList
    },
    secondMatterChange (data) {
      this.matter = data.matter
      this.remark = data.remark
      this.change()
    },
    secondMulMatterChange (data, value) {
      if (!this.matter) this.matter = {}
      if (!this.remark) this.remark = {}
      this.matter[value] = data.matter
      this.remark[value] = data.remark
      this.change()
    },
    change () {
      let value = this.getValue()
      this.$emit('input', {
        result: this.result,
        value: value,
        other: this.otherMap,
        remark: this.remark,
        matter: this.matter
      })
      this.validate()
    },
    textareaChange (reasonVal, item) {
      let obj = this.otherMap[reasonVal] || {}
      obj[item.prop] = item.otherValue
      this.otherMap[reasonVal] = obj
      this.change()
    },
    async validate (cb) {
      // 校验当前的 options 是否有被选中 必选的input是否输入内容
      let value = this.getValue()
      const refMattterList = this.$refs.matter || []
      let pass = true
      let secondMatter = true
      this.errmsgs = {}
      if (value.length) {
        // 判断是否有 input
        for (let i = 0; i < value.length; i++) {
          let key = value[i]
          let opt = this.options.find(item => {
            return item.value === (key - 0) && item.props && item.props.needOther
          })

          const refMatter = refMattterList.find(item => item.result === key)
          if (refMatter) {
            const tempPass = await refMatter.validate((res) => {
              pass = res
            })
            if (secondMatter) secondMatter = tempPass
          }
          if (opt) {
            let otherObj = this.otherMap[opt.value] || {}
            // {other: 123, kpPhone: 123455, shopPics: []}
            let other = Object.keys(otherObj).some(key => {
              return !!otherObj[key] || otherObj[key] === 0
            })

            if (opt.props.rules) {
              let checkVal = opt.props.rulesCheckProp ? otherObj[opt.props.rulesCheckProp] : otherObj
              const innerErrMsg = await this.rulesCheck(checkVal, opt.props.rules)
              this.errmsgs = Object.assign({}, this.errmsgs, {
                [key]: innerErrMsg
              })
              this.errmsgs[key] && (pass = false)
            }
            pass && (pass = other)
          }
        }
      } else {
        pass = false
      }
      const innerErrs = Object.values(this.errmsgs).filter(item => item)
      const hasInnerErr = innerErrs.length
      this.errmsg = errmsg
      this.showErr = !hasInnerErr && !pass
      cb && pass && secondMatter && cb(pass && secondMatter)
      return pass && secondMatter
    },
    rulesCheck (valueMap, list) {
      return new Promise(resolve => {
        for (let l = 0; l < list.length; l++) {
          let rules = list[l].rules || {}
          let msg = list[l].messages || {}
          let keys = Object.keys(rules)
          for (let i = 0; i < keys.length; i++) {
            let pass = rules[keys[i]](valueMap)
            if (isFunction(pass)) {
              // 表示异步校验
              pass((res) => {
                resolve(res ? '' : msg[keys[i]])
              })
              return false
            } else if (!pass) {
              resolve(msg[keys[i]] || '')
              return false
            }
          }
        }
        resolve('')
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.cascade-checker-second-wrapper
  .error-msg
    margin-top: 3px
    font-size: 12px
    color: #e64340
.check-required
  color: #e64340
  position: relative;
  top: 54Px;
  z-index: 1;
.pl-30
  padding-left: 30px
</style>
